angular
    .module('empower.control')
    .service('scrollToService', ['$timeout', function ($timeout) {
        return {
            scrollToTop: scrollToTop,
        };
        function scrollToTop(viewId) {
            $timeout(function () {
                $('html, body').animate({ scrollTop: $(viewId).position().top }, 'slow');
            });
        };
    }]);
